<template>
    <div>
        <div class="app-main__inner">
            <TituloComponente icono-titulo="fas fa-clipboard-list" texto-titulo="Situacion de Revista"  :to-create-action="{name:'NuevaSituacionRevista'}" to-create-text="Nueva Situacion de revista"/>
            <div class="tab-content">
                <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="main-card mb-3 card">
                                <div class="card-body">
                                    <h5 class="card-title">Listado de situacion de revista</h5>
                                     <DataList ref="datatable" url="/situacionrevista" :fields="fields" :rowClick="mostrarOpciones"></DataList>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                               
        </div>
    </div>
</template>
<script>
import TituloComponente from '@/components/layouts/TituloComponente';
import axios from 'axios';
//import Categoria from '@/models/categoria';
import DataList from '@/components/layouts/DataList';
import Swal from "sweetalert2";
export default {
    name: "ListarSituacionRevista",
    components: {
        TituloComponente,
        DataList,
    },
    data(){
        return{
            situacionRevista: [],
            fields: [
                {
                name: "codigo",
                label: "",
                type: "title",
                class: "",
                append: '-'
                },
                {
                name: "descripcion",
                label: "",
                type: "title",
                class: ""
                }
            ],
        }
    },
    created(){
    },
    mounted(){

    },
    methods:{
        mostrarOpciones(situacionRevista) {
            console.log(situacionRevista);
            Swal.fire({
                title: situacionRevista.descripcion,
                showCancelButton: true,
                confirmButtonText: "Editar",
                cancelButtonText: "Eliminar",
                confirmButtonColor: "#f7b924",
                cancelButtonColor: "#d33",
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                this.$router.push({name:'EditarSituacionRevista', params:{id:situacionRevista.id}})
                } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
                ) {
                this.eliminarSituacionRevista(situacionRevista)
                }
            });
        },        
        eliminarSituacionRevista(situacionRevista) {
        Swal.fire({
            title: "¿Estás seguro?",
            text: `¿Deseas eliminar ${situacionRevista.descripcion} de manera permanente?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
            this.loading = true;
            axios
                .delete("situacionrevista/" + situacionRevista.id)
                .then(res => {
                    console.log(res.data);
                Swal.fire(
                    "Eliminado",
                    `${res.data.situacionrevista.descripcion} se ha eliminado con éxito.`,
                    "success"
                );
                this.$refs.datatable.update();
                })
                .catch(err => console.log(err))
                .finally(() => (this.loading = false));
            }
        });
        }
    },
}
</script>
